import React from 'react';
import { ErrorMessage } from '../../ErrorMessage/ErrorMessage';
import styles from './Page.module.scss';
import { Spinner } from '~/ui/Spinner/Spinner';
import cn from 'classnames';

interface PageProps {
  heading: React.ReactNode;
  children: React.ReactNode;
  isError?: boolean;
  isLoading?: boolean;
  className?: string;
}

const Page = ({
  heading,
  children,
  isError,
  isLoading,
  className,
}: PageProps) => {
  const contentPage = () => {
    if (isError) {
      return <ErrorMessage />;
    } else if (isLoading) {
      return <Spinner />;
    } else {
      return children;
    }
  };

  return (
    <div id="page-container" className={cn(styles.page, className)}>
      <div className={styles.pageContainer}>
        <div className={styles.pageTop}>{heading}</div>
        <div className={styles.pageBottom}>{contentPage()}</div>
      </div>
    </div>
  );
};

export default Page;
